// extracted by mini-css-extract-plugin
export var errorsContainer = "_r1-1";
export var link = "_r1-0";